module.exports = __webpack_public_path__ + "static/media/04.9d50f3cc.png";